import {Flex, Heading, HStack, Text, VStack} from "@chakra-ui/react";
import styles from "../login/styles";
import React from "react";
import {ReactComponent as GoogleIcon} from "../../../assets/icons/googleIcon.svg";


export const GoogleAuth = ({isMobile}) => {

    return (
        <VStack
            mb={isMobile ? '18px' : '0'}
            spacing={'32px'}
            mt={'32px'}
            maxW={'458px'}
            mx={'auto'}>
            <Flex
                boxShadow={'0px 4px 4px 0px #00000040'}
                color={'neutral.500'}
                w={'full'}>
                <Text
                    css={styles.continueText}
                    fontSize={isMobile ? '12px' : '16px'}>
                    Or continue with
                </Text>
            </Flex>
            <HStack
                spacing={'32px'}>
                <Flex
                    alignItems={'center'}
                    justifyContent={'center'}
                    w={'90px'}
                    h={'70px'}
                    bg={'neutral.1100'}
                    border={'1px solid'}
                    borderColor={'neutral800'}
                    borderRadius={'8px'}>
                    <GoogleIcon/>
                </Flex>
                <Heading
                    fontSize={'heading.3xl'}
                    color={'neutral.100'}>
                    Google
                </Heading>
            </HStack>
        </VStack>
    )
}